<template>
  <div>
    <div :class="showMobileHeader ? 'tp_utl' : 'gnb_wrap'">
      <ul class="clear" v-if="username">
        <li>
          <a role="button" @click="logout()"><span>로그아웃</span></a>
        </li>
        <li class="arm">
          <router-link :to="{ name: 'alarm' }">
            <span>긴급알림</span><em>{{ alarmCount }}</em>
          </router-link>
        </li>
        <li class="crt">
          <router-link
            :to="{
              name: 'cart'
            }"
            ><span>장바구니</span><em>{{ cartCount }}</em></router-link
          >
        </li>
        <li
          :class="showMyPage ? 'mp on' : 'mp'"
          v-if="showMobileHeader === false"
        >
          <top-header-my-page
            :show-my-page.sync="showMyPage"
          ></top-header-my-page>
        </li>
      </ul>
      <ul class="clear" v-else>
        <li>
          <router-link
            @click.native="$emit('closeHeader')"
            :to="{
              name: 'login'
            }"
            ><span>로그인</span></router-link
          >
        </li>
        <li>
          <router-link
            :to="{
              name: 'join'
            }"
            ><span>회원가입</span></router-link
          >
        </li>
        <li class="crt">
          <router-link
            :to="{
              name: 'cart'
            }"
            ><span>장바구니</span><em>{{ cartCount }}</em></router-link
          >
        </li>
      </ul>
    </div>
    <top-header-my-page
      v-if="showMobileHeader"
      :show-mobile-header="showMobileHeader"
      :show-my-page.sync="showMyPage"
      @closeHeader="$emit('closeHeader')"
    ></top-header-my-page>
    <transition name="fade">
      <div
        class="mo_bg"
        v-show="showMyPage === true && showMobileHeader === true"
      ></div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TopHeaderMyPage from './TopHeaderMyPage'

export default {
  name: 'TopHeader',
  props: {
    showMobileHeader: {
      default: false
    }
  },
  components: { TopHeaderMyPage },
  directives: {},
  computed: {
    ...mapGetters([
      'name',
      'username',
      'device',
      'memberLevelInfo',
      'cartCount',
      'alarmCount'
    ])
  },
  data() {
    return {
      showMyPage: false,
      topMenu: [
        {
          Id: 0,
          name: '주문/배송조회',
          status: true,
          url: 'orderList',
          parent_id: 0
        },
        {
          Id: 0,
          name: '찜한 상품',
          status: true,
          url: 'favor',
          parent_id: 0
        },
        {
          Id: 0,
          name: '적립금충전',
          status: true,
          url: 'point',
          parent_id: 0
        },
        {
          Id: 0,
          name: '1:1문의',
          status: true,
          url: 'qna',
          parent_id: 0
        },
        {
          Id: 0,
          name: '정보관리',
          status: true,
          url: 'member',
          parent_id: 0
        }
      ]
    }
  },
  methods: {
    logout() {
      this.$emit('closeHeader')
      this.$store.dispatch('LogOut').then(() => {
        window.location.reload() // 버그를 피하기 위하여 vue-router 객체를 다시 인스턴스화
      })
    },
    closeHeader() {
      this.$emit('closeHeader')
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.gnb_sl .swiper-container {
  padding: 0 10px;
}

/* my page*/
div.mp {
  cursor: pointer;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Header/components/TopHeader.vue